export const ID = 'id';
export const COMPLETION_PERCENTAGE = 'completionPercentage';
export const NOTE = 'note';
export const REQUEST_TASK_ID = 'requestTaskId';
export const TASK_PROGRESSE_IMAGE_URL = 'taskProgressImageUrl';
export const WORKER = 'worker';
export const CREATED_AT = 'createdAt';
